module.exports = __webpack_public_path__ + "img/p16.044f53bb.png";